import React from "react";
import PropTypes from "prop-types";
import styles from "./UplineItem.module.css";

/**
 * View component. Displays information about an upline in the uplines list.
 */
export function UplineItem({ uplineInfo }) {
  return (
    <div className={styles.gridContainer}>
      <div className={styles.gridItem}>{uplineInfo.upline}</div>
      <div className={styles.gridItem}>{uplineInfo.name}</div>
      <div className={styles.gridItem}>{uplineInfo.iboNum}</div>
      <div className={styles.gridItem}>{uplineInfo.dsId}</div>
    </div>
  );
}

UplineItem.propTypes = {
  /**
   * Object with the uplines info.
   */
  uplineInfo: PropTypes.shape({
    upline: PropTypes.string,
    name: PropTypes.string,
    iboNum: PropTypes.string,
    dsId: PropTypes.string,
  }),
};
